var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth",attrs:{"id":"auth","name":"auth"}},[_c('div',{staticClass:"top"},[_c('NavTop',{attrs:{"activeIndex":"3"}})],1),_c('div',{staticClass:"content-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.tetx)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }